import {FC, useState, createContext, useContext} from 'react'
import {WithChildren} from '../../../../../../_metronic/helpers'

type ListViewContextType = {
  itemIdForUpdate?: string
  setItemIdForUpdate: (id?: string) => void
}

const ListViewContext = createContext<ListViewContextType | undefined>(undefined)

const ListViewProvider: FC<WithChildren> = ({children}) => {
  const [itemIdForUpdate, setItemIdForUpdate] = useState<string | undefined>()

  return (
    <ListViewContext.Provider value={{itemIdForUpdate, setItemIdForUpdate}}>
      {children}
    </ListViewContext.Provider>
  )
}

const useListView = () => {
  const context = useContext(ListViewContext)
  if (!context) {
    throw new Error('useListView must be used within ListViewProvider')
  }
  return context
}

export {ListViewProvider, useListView}
